import { AA, Method, Resource } from 'sdk';

/**
 * We have two different ways that we are trying to send client
 * side errors to the server. We should unify them or at the very least
 * reconcile why we need both. The other is {@link app/utils/ClientSideMetrics}
 *
 * This one sends the errors to HAAWA ErrorLogsController which get picked up by RTLA from there.
 *
 * TODO: https://sim.amazon.com/issues/AUTHOR-11061
 */
class ClientSideErrorActionCreator {
  log(message, error, location) {
    let path;
    /* defensively check if the location passed in
    is an object or a string. Different places
    in our code do different things. */
    if (location.pathname) {
      path = location.pathname + location.search;
    } else {
      path = location;
    }

    const logParams = {
      message,
      // Some browsers don't provide an error object on error
      stackTrace: error ? error.stack : null,
      path,
    };
    AA.api(Resource.errorLogs, Method.post, logParams);
  }
}

export default new ClientSideErrorActionCreator();
